export default __webpack_public_path__ + "static/media/standard_hrv.cdc9b9da.png";